import React from 'react';
import { SectionSkeleton, SECTION_SKELETON_VARIANTS } from './SectionSkeleton';

/**
 * TableSkeleton — backward-compatible wrapper.
 *
 * @deprecated Use `<SectionSkeleton variant="table" />` instead.
 * @param {boolean} isMobile - viewport flag [Optional]
 * @param {string} title - section title [Optional]
 */
export const TableSkeleton = ({ isMobile, title }) => (
  <SectionSkeleton
    variant={SECTION_SKELETON_VARIANTS.table}
    isMobile={isMobile}
    title={title}
  />
);
